import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "bootstrap-icons/font/bootstrap-icons.css"; // If you want to use Bootstrap icons
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import Footer from "./features/layout/Footer";
import Header from "./features/layout/Header";
import EbookMain from "./features/pages/freeEbook/ebookMain";
import ViewEbook from "./features/pages/freeEbook/viewEbook";
import GlossaryMain from "./features/pages/glossary/financeGlossary/GlossaryMain";
import GlossaryMainTech from "./features/pages/glossary/financeGlossary/GlossaryMainTech";
import LumpsumCalculator from "./features/pages/lumspsumCalculator/LumpsumCalculator";
import LogInQuiz from "./features/pages/quizModule/logInQuiz";
import QuizComplete from "./features/pages/quizModule/quizComplete";
import QuizQuestions from "./features/pages/quizModule/quizQuestions";
import QuizUserRegisterView from "./features/pages/quizModule/quizUserRegisterView";
import SignUp from "./features/pages/quizModule/signUp";
import StartQuiz from "./features/pages/quizModule/startQuiz";
import RegulatoryUpdates from "./features/pages/regulatoryUpdates/regulatoryUpdates";
import RegulatoryUpdatesView from "./features/pages/regulatoryUpdates/regulatoryUpdatesView";
import RiskAnalyzer from "./features/pages/riskAnalyzer/riskAnalyzer";
import RiskAnalyzerlanding from "./features/pages/riskAnalyzer/riskAnalyzerlanding";
import RiskProfile from "./features/pages/riskAnalyzer/RiskProfile";
import SIPCalculator from "./features/pages/sipCalculator/SIPCalculator";
import Start from "./util/start";

function App() {
  return (
    <BrowserRouter>
      <>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Start />}></Route>

            <Route path="/Quiz" element={<StartQuiz />}></Route>

            {/* quiz swction */}
            <Route path="/quiz/:id/:topic" element={<QuizQuestions />}></Route>
            <Route
              path="/QuizDone/:id/:topic"
              element={<QuizComplete />}
            ></Route>
            <Route
              path="/QuizRank/:id/:topic"
              element={<QuizUserRegisterView />}
            ></Route>

            {/* calculator section */}
            <Route path="/SipCalculator" element={<SIPCalculator />}></Route>
            <Route
              path="/LumpsumCalculator"
              element={<LumpsumCalculator />}
            ></Route>

            {/* glossary section */}
            <Route path="/Glossary" element={<GlossaryMain />}></Route>
            <Route path="/GlossaryTech" element={<GlossaryMainTech />}></Route>

            {/* regulatory updates */}
            <Route
              path="/RegulatoryUpdates"
              element={<RegulatoryUpdates />}
            ></Route>
            <Route
              path="/RegulatoryUpdatesView/:id"
              element={<RegulatoryUpdatesView />}
            ></Route>

            {/* auth pages */}
            <Route path="/SignUp/:id/:topic" element={<SignUp />}></Route>
            <Route path="/LogInQuiz/:id/:topic" element={<LogInQuiz />}></Route>

            {/* ebook section */}
            <Route path="/EbookMain" element={<EbookMain />}></Route>
            <Route path="/ViewEbbok/:id" element={<ViewEbook />}></Route>
            {/* riskAnalyzerlanding */}
            <Route
              path="/RiskAnalyser"
              element={<RiskAnalyzerlanding />}
            ></Route>
            <Route
              path="/RiskAnalyzerCalculate/:email/:username"
              element={<RiskAnalyzer />}
            ></Route>
            <Route
              path="/RiskProfile/:id/:email/:username"
              element={<RiskProfile />}
            ></Route>

            {/* <Route path="*" element={<NoMatch />} ></Route> */}
            {/* "build:prod": "env-cmd -f .env.production npm run  build", */}
          </Routes>
        </main>
        <Footer />
      </>
    </BrowserRouter>
  );
}

export default App;
